import React from "react";
import { Grid, Box, Card, CardContent, Typography } from "@mui/material";
import { Messages } from "./types";
import MessageCard from "./MessageCard";

interface Props {
  messages: Messages[];
  onEdit?: (message: Messages) => void;
  emptyMessage?: string;
}

const MessageList: React.FC<Props> = ({ messages, onEdit, emptyMessage }) => {
  return (
    <Grid
      container
      justifyContent="center"
      className="custom-scrollbar-css"
      sx={{ height: "45vh" }}>
      <Grid item xs={12} md={10} lg={8}>
        {messages && messages.length > 0 ? (
          messages.map((m) => (
            <MessageCard key={m.id} message={m} onEdit={onEdit} />
          ))
        ) : (
          <Card
            variant="outlined"
            sx={{
              borderRadius: 1,
              mb: 1,
              boxShadow: "0px 2px 6px rgba(0,0,0,0.05)",
              "&:hover": { boxShadow: "0px 4px 10px rgba(0,0,0,0.1)" },
              p: 1.5,
            }}>
            <CardContent>
              <Box>
                <Typography>{emptyMessage}</Typography>
              </Box>
            </CardContent>
          </Card>
        )}
      </Grid>
    </Grid>
  );
};

export default MessageList;
